module.exports = __webpack_public_path__ + "img/asset_pack.dd7d2e0f.png";